import { IIndexable } from './interfaces';

/**
 * Read a page's GET URL variables and return them as an associative array
 * search (optional) - '?me=myValue&name2=SomeOtherValue'
 *
 * Usage:
 * ------
 * getQueryString(); //window.location.search
 * getQueryString('?me=myValue&name2=SomeOtherValue');
 * getQueryString()['key'] -> value
 *
 * Result:
 * -------
 * {
 *   "me"    : "myValue",
 *   "name2" : "SomeOtherValue"
 * }
 *
 */
export const getQueryString = (search?: string, caseSensitive: boolean = true) : IIndexable => {

    const result = {} as IIndexable;

    if(!search){
        search = window.location.search;
    }

    // decode if needed
    search = window.decodeURIComponent(search.toString());

    if(!caseSensitive){
        search = search?.toLowerCase();
    }

    if(search.length <= 1) return result;

    // get hashes
    const hashes = search.substring(1).split('&');

    for(let i = 0; i < hashes.length; i++){

        //get hash
        const hash = hashes[i];

        //get hash sections
        const sections = hash.split('=');

        if(sections.length >= 2){

            let val = '';

            for(let s=1; s<sections.length; s++){

                if(s > 1){
                    val += '=';
                }

                val += sections[s];
            }

            //add to the object
            result[sections[0]] = val;
        }
    }

    return result;
};

/**
 * generate return URL that includes query string and hashes
 * https://www.waves.com/login?ReturnUrl=/vocal-mixing-masterclass-leslie-brathwaite?playlist=756640c2-13c0-408b-ad77-0294173d7721
 */
export const getReturnURL = (prefix = '/login') => {
    /*
    const qs = Object.entries(getQueryString()).map(([key, value], index) => `${key}=${value}`); //
    qs.push(`returnurl=${encodeURIComponent(window.location.pathname)}`);
    return `/login?${qs.join('&')}`*/

    const returnURL = `ReturnUrl=${window.location.pathname}${window.location.search}${window.location.hash}`;
    return `${prefix}?${returnURL}`
};

export const removeQueryParamFromUrl = (queryParam: string) => {
    if(!queryParam || typeof URLSearchParams === 'undefined') return;

    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    if(params.has(queryParam)){
        params.delete(queryParam);
        url.search = params.toString();
    }

    window.history.replaceState({}, '', url.toString());
};